import { Action } from '../../common/actions/core/action';
import { MasterpassOTPTypes } from '../services/payment-method.model';

export class OpenMasterpassCardAddOtpAction implements Action {
  constructor(public onApprove: (code:string, stopTimer: any, stopOtpReqSent: any) => any, 
              public onResend:() => any,
              public otpType: MasterpassOTPTypes
              ) {}
}



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-add-otp-dialog/masterpass-card-add-otp-dialog.action.ts